"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.format.pdf': 'PDF',
    'slot.format.csv': 'CSV',
};
